/**
 * Request Quote Form - SKU to Product Mapping
 * Handles URL parameter mapping from SKU to full product text for Zoho form
 */

// Static product list with full text by SKU
const PRODUCT_LIST = {
  TW50: "TW50 LITE Headphone - 3.5mm Black",
  TW55: "TW55 LITE Headset - 3.5mm Black",
  TW100: "TW100 ERGO Headphone - 3.5 mm Black",
  TW102: "TW102 ERGO Headphone - USB-A Black",
  TW103: "TW103 ERGO Headphone - USB-C Black",
  TW110: "TW110 ERGO Headset - 3.5 mm Black",
  TW120: "TW120 ERGO Headset - USB-A Black",
  TW130: "TW130 ERGO Headset - USB-C Black",
  TW200: "TW200 DURO Headphone - 3.5 mm Black",
  TW210: "TW210 DURO Headset - 3.5 mm Black",
  TW220: "TW220 DURO Headset - USB-A Black",
  TW250XG: "TW250XG Victory Gaming Headset - 3.5 mm Black",
  TW350XG: "TW350XG Victory Gaming Headset - 3.5 mm & USB-A Black",
  TW300: "TW300 REVO Headphone - 3.5 mm Black",
  TW310: "TW310 REVO Headset - 3.5 mm Black",
  TW320: "TW320 REVO Headset - USB-A Black",
  TW330: "TW330 REVO Headset - USB-C Black",
  TW340: "TW340 REVO Headset - Bluetooth",
  "TWBC-1": "TWBC-1 FLEX Adapter (10 units/pack)",
  "TWRC-1": "TWRC-1 REVO Cable - 3.5mm",
  "TWRC-2": "TWRC-2 REVO Cable - USB-A",
  "TWRC-3": "TWRC-3 REVO Cable - USB-C",
  "TW-EP1": "TW-EP1 REVO Ear Pad",
};

const ZOHO_FORM_BASE_URL =
  "https://forms.zohopublic.com/twtaudio1/form/RequestAQuote1/formperma/pY53WabXi15Kzc-uxFMuMXDJAFQqzi8Ovsu1wavOHuw";

/**
 * Initialize the form with pre-filled data from URL parameters
 */
function initializeRequestQuoteForm() {
  const urlParams = new URLSearchParams(window.location.search);
  const sku = urlParams.get("sku");
  const iframe = document.getElementById("zoho-form-iframe");

  if (!iframe) {
    console.warn("Zoho form iframe not found");
    return;
  }

  if (!sku) {
    // No SKU provided, load default form
    return;
  }

  const fullProductText = PRODUCT_LIST[sku];

  if (!fullProductText) {
    console.warn(`Unknown SKU: ${sku}`);
    return;
  }

  // Update iframe src with pre-filled product data
  const newSrc = `${ZOHO_FORM_BASE_URL}?MultipleChoice=${encodeURIComponent(fullProductText)}`;
  iframe.src = newSrc;

  console.log(`Pre-filled form with: ${fullProductText}`);
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeRequestQuoteForm);
} else {
  initializeRequestQuoteForm();
}
